import { FetchError, FetchErrorConstructorProps } from './FetchError';

type NetworkFetchErrorPropNames = 'statusText' | 'error' | 'requestUrl' | 'fetchRetryN' | 'loggerFields';

/**
 * NetworkFetchError наследуется от FetchError для удобства обработки ошибок, status в FetchError обязательный.
 * Подойдет любой не являющийся http статус. Также это дополнительное поле для удобства поиска ошибок.
 */
const STUB_STATUS = 0;

export class NetworkFetchError extends FetchError {
    constructor(props: Pick<FetchErrorConstructorProps, NetworkFetchErrorPropNames>) {
        super({
            status: STUB_STATUS,
            ...props,
        });

        Object.setPrototypeOf(this, NetworkFetchError.prototype);
    }
}
